export const getWaiparaValleyData = () => ({
  name: "Waipara Valley",
  region: "Canterbury",
  country: "Nouvelle-Zélande",
  description: "La Waipara Valley est la vallée principale de Canterbury, spécialisée dans les vins blancs frais et les vins rouges élégants. Cette sous-région bénéficie d'un climat maritime avec des influences alpines, créant des conditions idéales pour la viticulture de qualité.",
  type: "subregion",
  area: "800 ha",
  production: "0.06 million hectolitres",
  climate: "Climat maritime avec influences alpines, étés frais et hivers froids",
  soil: "Sols calcaires, excellente drainage, faible fertilité",
  characteristics: {
    climate: "Climat maritime avec influences alpines, étés frais et hivers froids",
    soil: "Sols calcaires, excellente drainage, faible fertilité",
    viticulture: "Viticulture durable, rendements contrôlés, qualité privilégiée"
  },
  wineStyles: {
    white: "Vins blancs frais et minéraux, avec une belle acidité",
    red: "Pinot Noir élégant avec tanins fins et notes de fruits rouges",
    rosé: "Rosés délicats et fruités, parfaits pour l'apéritif"
  },
  history: "La viticulture dans la Waipara Valley a commencé dans les années 1980 avec les premiers vignobles commerciaux. La région a développé une réputation pour ses vins blancs de qualité, notamment le Chardonnay et le Sauvignon Blanc. Aujourd'hui, la Waipara Valley est reconnue comme l'un des meilleurs terroirs de Canterbury.",
  foodPairing: "Fruits de mer, poissons blancs, fromages locaux, plats d'hiver, cuisine locale",
  grapeVarieties: [
    {
      name: "Chardonnay",
      percentage: "40%",
      description: "Cépage blanc principal, produisant des vins secs et minéraux",
      characteristics: "Sec, minéral, acidité vive",
      wineStyles: "Sec, moyen-corps, complexe"
    },
    {
      name: "Sauvignon Blanc",
      percentage: "30%",
      description: "Cépage blanc produisant des vins frais et aromatiques",
      characteristics: "Frais, aromatique, acidité vive",
      wineStyles: "Sec, léger, aromatique"
    },
    {
      name: "Pinot Noir",
      percentage: "20%",
      description: "Cépage rouge principal, produisant des vins élégants avec des tanins fins",
      characteristics: "Élégant, tanins fins, fruits rouges",
      wineStyles: "Sec, moyen-corps, complexe"
    },
    {
      name: "Riesling",
      percentage: "10%",
      description: "Cépage blanc produisant des vins secs et aromatiques",
      characteristics: "Sec, aromatique, acidité vive",
      wineStyles: "Sec à demi-sec, aromatique"
    }
  ],
  statistics: {
    totalArea: "800 ha",
    production: "0.06 million hectolitres",
    wineries: "25+ domaines",
    exportPercentage: "50%"
  },
  viticulture: "La viticulture dans la Waipara Valley se caractérise par l'attention aux détails et la recherche de la qualité. Les rendements sont contrôlés pour préserver l'intensité aromatique et la concentration. La viticulture durable et l'innovation technologique sont des priorités.",
  winemaking: "La vinification se fait principalement en acier inoxydable pour préserver la fraîcheur et les arômes primaires. La fermentation à basse température et l'utilisation de levures sélectionnées sont courantes. L'élevage sur lies est parfois pratiqué pour ajouter de la texture.",
  terroir: "La Waipara Valley est caractérisée par ses sols calcaires et son climat maritime avec influences alpines. Les sols offrent un excellent drainage et une faible fertilité, forçant les vignes à développer des racines profondes. Le climat apporte des influences océaniques et alpines qui modèrent les températures.",
  mapAreas: [
    { region: "Waipara Valley", x: 172.5, y: -43.5, color: "#4B164C", size: 4 }
  ]
}); 